import clsx from 'clsx'
import React, { FC, useState } from 'react'
import { HeaderLanguage, HeaderUserMenu } from '../../../partials'
import { HeaderLocationsMenu } from '../../../partials/layout/header-menus/HeaderLocationsMenu'
import { KTSVG } from '../../../helpers'
import ThemeToggle from '../ThemeToggle'
import { getSelectedLocation } from '../../../../utils'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const Topbar: FC = () => {
  const [clickCapture, setClickCapture] = useState(false)
  const selectedLocation = getSelectedLocation()
  const isBanned = selectedLocation ? (selectedLocation.is_active === "0" || selectedLocation.is_active === 0 || new Date(selectedLocation.expire) < new Date()) : false

  const handleClick = () => {
    setClickCapture(!clickCapture)
  }

  return (
    <>
      <style>{`
        .location-status-badge {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        .location-status-dot {
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          animation: pulse 2s infinite;
        }

        .location-status-dot.active {
          background-color: #28a745;
          box-shadow: 0 0 8px rgba(40, 167, 69, 0.6);
        }

        .location-status-dot.banned {
          background-color: #dc3545;
          box-shadow: 0 0 8px rgba(220, 53, 69, 0.6);
          animation: pulse-danger 2s infinite;
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        @keyframes pulse-danger {
          0%, 100% {
            opacity: 1;
            box-shadow: 0 0 8px rgba(220, 53, 69, 0.6);
          }
          50% {
            opacity: 0.6;
            box-shadow: 0 0 12px rgba(220, 53, 69, 0.8);
          }
        }

        .location-status-icon {
          position: relative;
        }

        .location-btn-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .location-btn-wrapper::after {
          content: '';
          position: absolute;
          bottom: -2px;
          right: -2px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #28a745;
        }

        .location-btn-wrapper.banned::after {
          background-color: #dc3545;
          animation: pulse-danger-badge 2s infinite;
        }

        @keyframes pulse-danger-badge {
          0%, 100% {
            box-shadow: 0 0 6px rgba(220, 53, 69, 0.7);
          }
          50% {
            box-shadow: 0 0 10px rgba(220, 53, 69, 0.9);
          }
        }
      `}</style>

      <div className='d-flex align-items-stretch flex-shrink-0'>
        {/* ── TEMA TOGGLE ── */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <ThemeToggle />
        </div>
        {/* ── END TEMA TOGGLE ── */}

        {/* LOCATIONS */}
        <div
          onClick={handleClick}
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx(
              'location-btn-wrapper cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
              toolbarUserAvatarHeightClass,
              { 'banned': isBanned }
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
            title={isBanned ? '🚫 Konum devre dışı' : '✓ Konum aktif'}
          >
            <KTSVG path='/media/icons/bootstrap/header/geo-alt-fill.svg' className='svg-icon-2' />
          </div>
          <HeaderLocationsMenu test={clickCapture} />
        </div>
        {/* END LOCATIONS */}

        {/* begin::Language */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx(
              'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
              toolbarUserAvatarHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTSVG path='/media/icons/bootstrap/header/globe2.svg' className='svg-icon-2' />
          </div>
          <HeaderLanguage />
        </div>
        {/* end::language */}

        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx(
              'cursor-pointer symbol btn btn-icon btn-active-light-primary btn-custom',
              toolbarUserAvatarHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <KTSVG path='/media/icons/bootstrap/header/person-fill.svg' className='svg-icon-1' />
          </div>
          <HeaderUserMenu />
        </div>
        {/* end::User */}
      </div>
    </>
  )
}

export { Topbar }